import Grid from '@material-ui/core/Grid';
import { createStyles, makeStyles, Theme } from '@material-ui/core';

import React from 'react';
import { useSelector } from 'react-redux';

import { baseTheme } from '../../../theme';
import LeaderItem from '../leader-results';
import FollowedItem from '../leader-followed-results';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0),
    },
    searchBorder: {
      borderTop: `solid 5px ${theme.palette.primary.main}`,
    },
  }),
);

export default function LeaderSearchResults(props: any) {
  const classes = useStyles(baseTheme);
  const leaders = useSelector((state: any) => state.leaders.list);
  const leaderSearched = useSelector((state: any) => state.leaders.listLoaded);
  const followedLeaders = useSelector((state: any) => state.leaders.follow);
  const followedFilter = useSelector((state: any) => state.leaders.followFilter);
  const renderLeaders = () => leaders?.length
    ? leaders
      .map((leader: any) => {
        return (<LeaderItem {...leader} />);
      })
    : 'Not Results found';

  const renderFollowed = () => followedLeaders
    .filter((item: any) => item.leader.id === followedFilter || followedFilter === 'all')
    .map((item: any) => {
      return (<FollowedItem {...item} />);
    });

  return (
    <Grid item container className={`${classes.root} ${followedLeaders.length || leaders.length ? classes.searchBorder : ''}`} xs={12}>
      {
        leaderSearched
          ? renderLeaders()
          : renderFollowed()
      }
    </Grid>
  );
}
